module.exports = __webpack_public_path__ + "static/media/60_tn.0bc68b8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/60_tn.jpg
// module id = 547
// module chunks = 0